import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { usePermissions } from '@/shared/hooks/usePermissions'

type UsersAccessGateProps = {
  children: ReactNode
}

export function UsersAccessGate({ children }: UsersAccessGateProps) {
  const { t } = useTranslation(['organizationUsers', 'common'])
  const { checkPermission } = usePermissions()
  const { installationId } = useParams<{ installationId: string }>()
  const canManageUsers = checkPermission('organization', 'manage-users')
  const dashboardPath = installationId
    ? `/dashboard/${installationId}`
    : '/'

  if (!canManageUsers) {
    return (
      <div className="flex flex-1 items-center justify-center p-6">
        <Card className="max-w-md">
          <CardHeader>
            <CardTitle>{t('common:nav.permissionDenied')}</CardTitle>
            <CardDescription>
              {t('organizationUsers:access.permissionDeniedDescription')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild variant="secondary">
              <Link to={dashboardPath}>{t('common:actions.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    )
  }

  return <>{children}</>
}
